import { FC } from 'react'
import { DefaultProps } from '../../common'

type AlertInfoIconProps = DefaultProps & {
  width?: number
  height?: number
}

export const AlertInfoIcon: FC<AlertInfoIconProps> = ({
  className,
  id,
  testId,
  ariaLabel,
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(!ariaLabel ? { 'aria-hidden': true, role: 'presentation' } : {})}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.3" cx="20" cy="20" r="20" fill="#AEDCFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 20C10.25 14.6152 14.6152 10.25 20 10.25C25.3848 10.25 29.75 14.6152 29.75 20C29.75 25.3848 25.3848 29.75 20 29.75C14.6152 29.75 10.25 25.3848 10.25 20ZM18.9562 18.5584C20.1025 17.9853 21.3931 19.0206 21.0823 20.2639L20.3733 23.0999L20.4148 23.0792C20.7852 22.894 21.2357 23.0441 21.421 23.4146C21.6062 23.7851 21.4561 24.2356 21.0856 24.4208L21.0441 24.4416C19.8979 25.0147 18.6072 23.9794 18.9181 22.7361L19.6271 19.9001L19.5856 19.9208C19.2151 20.1061 18.7646 19.9559 18.5793 19.5854C18.3941 19.2149 18.5443 18.7644 18.9148 18.5792L18.9562 18.5584ZM20 17C20.4142 17 20.75 16.6642 20.75 16.25C20.75 15.8358 20.4142 15.5 20 15.5C19.5858 15.5 19.25 15.8358 19.25 16.25C19.25 16.6642 19.5858 17 20 17Z"
        fill="#35A8FD"
      />
    </svg>
  )
}
